import { render } from "./forgot.page.vue?vue&type=template&id=b920cb92&ts=true"
import script from "./forgot.page.vue?vue&type=script&lang=ts"
export * from "./forgot.page.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__